export const LOGIN_INTENTS = {
  personalizedDemo: "personalized-demo",
} as const;

export type LoginIntent = (typeof LOGIN_INTENTS)[keyof typeof LOGIN_INTENTS];

/** Accepts only product-owned login contexts; arbitrary URL copy is ignored. */
export const readLoginIntent = (value?: string): LoginIntent | undefined => {
  if (value === LOGIN_INTENTS.personalizedDemo) {
    return LOGIN_INTENTS.personalizedDemo;
  }
  return undefined;
};

